import Routes from "routes"
import ThemeCustomization from "themes"
import Locales from "components/Locales"
import RTLLayout from "components/RTLLayout"
import ScrollTop from "components/ScrollTop"
import Snackbar from "components/@extended/Snackbar"
import Notistack from "components/third-party/Notistack"
import { JWTProvider as AuthProvider } from "contexts/JWTContext"
import { TracksProvider } from "./contexts/TracksContext"
import { ArtistsProvider } from "./contexts/ArtistsContext"
import { CompaniesProvider } from "contexts/CompaniesContext"
import { ReportsProvider } from "./contexts/ReportsContext"
import { PlaylistsProvider } from "./contexts/PlaylistContext"
import { useEffect } from "react"
import { ArtistsKahunaProvider } from "contexts/ArtistsKahunaContext"
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext'
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext'
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context'

const App = () => {
  /*const [loading, setLoading] = useState<boolean>(true)

  if (loading) return <Loader />*/

  useEffect(() => {
    const isWindows = navigator.platform.includes("Win")

    if (isWindows) {
      //@ts-ignore
      import("./Scrollbar.css")
    }

    const url = window.location.origin
    if (url.includes("tunefund.io")) {
      document.title = `Tunefund - Offers`
      const existingFavicons = document.querySelectorAll("link[rel='icon']")
      //@ts-ignore
      existingFavicons.forEach((f) => f.parentNode.removeChild(f))

      const link = document.createElement("link")
      link.rel = "icon"
      link.href = "/favicon-tunefund.ico"
      document.head.appendChild(link)
    } else if (url.includes("slush.kahuna.io")) {
      document.title = `Kahuna`
    }
  }, [])

  return (
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <ScrollTop>
            <AuthProvider>
              <ArtistsProvider>
                <PlaylistsProvider>
                  <TracksProvider>
                    <CompaniesProvider>
                      <ArtistsKahunaProvider>
                        <ReportsProvider>
                          <Notistack>
                            <Routes />
                            <Snackbar />
                          </Notistack>
                        </ReportsProvider>
                      </ArtistsKahunaProvider>
                    </CompaniesProvider>
                  </TracksProvider>
                </PlaylistsProvider>
              </ArtistsProvider>
            </AuthProvider>
          </ScrollTop>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  )
}

export default App
